import logService from '../wss/logService3';
import { publish } from '../utils/pubsub';
import { events } from '../wss/SystemEvents';
import EngineBase2 from './EngineBase2';

import _cache from './QuotaCache';

const _name = 'QuotaEngine';

class QuotaEngine extends EngineBase2 {
    /**
     * Initializes cache and subscribes to socket events.
     * Called from PageContent on login — does not fetch.
     */
    bootup = () => {
        try {
            this.initialize(_name, _cache);

            // this was for EngineBase old version
            // for catch onClearCacheEvent
            // this.subscribe();
        } catch (error) {
            logService.logError(`${_name}.bootup: error=${error.message}`);
        }
    };

    /**
     * Loads quota items into cache and publishes the initial list.
     * Called from DashboardPage after fetchUser.
     * @param {Array} items - UserQuotaDto[]
     */
    load = (items) => {
        try {
            _cache.setItems(items ?? []);
            publish(events.onQuotaUpdated, _cache.getItems());
        } catch (error) {
            logService.logError(`${_name}.load: error=${error.message}`);
        }
    };

    getItems = () => {
        return _cache.getItems();
    };

    /**
     * Returns quota items mapped to dropdown format.
     * Sorted alphabetically by label.
     * @returns {{ label: string, value: string }[]}
     */
    getDropdownItems = () => {
        return _cache
            .getItems()
            .map((q) => ({ label: q.name, value: q.name }))
            .sort((a, b) => a.label.localeCompare(b.label));
    };

    /**
     * Handles SignalR socket data for quota events.
     * OnQuotaUpdated — upserts each item, publishes updated list.
     * OnQuotaDeleted — removes each item by name, publishes updated list.
     */
    handleSocketData = (p) => {
        try {
            if (p.A === events.onQuotaUpdated) {
                const items = JSON.parse(p.D) ?? [];

                items.forEach((item) => {
                    // Publish dedicated event when a new topic appears for the first time
                    const isNew = !_cache.getItems().find((x) => x.name === item.name);
                    if (isNew) {
                        publish(events.onTopicAdded, item);
                    }
                    _cache.upsert(item);
                });
                publish(events.onQuotaUpdated, _cache.getItems());
                return;
            }

            if (p.A === events.onQuotaDeleted) {
                const items = JSON.parse(p.D) ?? [];

                items.forEach((item) => _cache.removeByName(item.name));

                publish(events.onQuotaDeleted, _cache.getItems());
                return;
            }
        } catch (error) {
            logService.logError(`${_name}.handleSocketData: error=${error.message}`);
        }
    };
}

const quotaEngine = new QuotaEngine();
export default quotaEngine;
